<template>
    <div>
        <div class="reporting-list">
            <div>
                <div>Odeslané pozvánky</div>
                <div>{{ invitationsPatients }}</div>
                <div>{{ invitationsPeriodPatients }}</div>
            </div>
        </div>
        <div class="reporting-list">
            <div>
                <div>Letáky v oběhu</div>
                <div>{{ flyersPatients }}</div>
                <div>{{ flyersPeriodPatients }}</div>
            </div>
        </div>
        <div class="reporting-list">
            <div>
                <div>Letáky v oběhu (využité)</div>
                <div>{{ flyersUsedPatients }}</div>
                <div>{{ flyersUsedPeriodPatients }}</div>
            </div>
        </div>
        <div class="reporting-list disable-item">
            <div>
                <div style="width: 51%">Vypršené pozvánky (letáky)</div>
                <div>
                    {{ expiredInvitationsPatients }} ({{ expiredFlyersPatients }})
                    <div class="reporting-info-icon">
                        <a>
                            <svg-icon icon="tooltips.small-info" />
                            <svg-icon icon="tooltips.small-info-hover" />
                            <div class="reporting-info-content invited">
                                Pozvánka vypršela po 30 dnech od odeslání pozvánky nebo od prvního zadání kódu z letáku.
                            </div>
                        </a>
                    </div>
                </div>
                <div>
                    {{ expiredInvitationsPeriodPatients }} ({{ expiredFlyersPeriodPatients }})
                    <div class="reporting-info-icon">
                        <a>
                            <svg-icon icon="tooltips.small-info" />
                            <svg-icon icon="tooltips.small-info-hover" />
                            <div class="reporting-info-content invited">
                                Pozvánka vypršela po 30 dnech od odeslání pozvánky nebo od prvního zadání kódu z letáku.
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapActions, mapGetters } from 'vuex'

    export default {
        data() {
            return {
                defaultDateFrom: moment()
                    .add(-7, 'days')
                    .format('YYYY-MM-DD'),
                defaultDateTo: moment().format('YYYY-MM-DD'),
                regionsLocalStorageParsed: [],
                companiesLocalStorageParsed: [],
                dateFromLocalStorage: '',
                dateToLocalStorage: '',
                fetching: true
            }
        },
        computed: {
            ...mapGetters('reporting', [
                'invitations',
                'invitationsPeriod',
                'flyers',
                'flyersPeriod',
                'flyersUsed',
                'flyersUsedPeriod',
                'expiredInvitations',
                'expiredInvitationsPeriod',
                'expiredFlyers',
                'expiredFlyersPeriod'
            ]),
            invitationsPatients() {
                return this.invitations
            },
            invitationsPeriodPatients() {
                return this.invitationsPeriod
            },
            flyersPatients() {
                return this.flyers
            },
            flyersPeriodPatients() {
                return this.flyersPeriod
            },
            flyersUsedPatients() {
                return this.flyersUsed
            },
            flyersUsedPeriodPatients() {
                return this.flyersUsedPeriod
            },
            expiredInvitationsPatients() {
                return this.expiredInvitations
            },
            expiredInvitationsPeriodPatients() {
                return this.expiredInvitationsPeriod
            },
            expiredFlyersPatients() {
                return this.expiredFlyers
            },
            expiredFlyersPeriodPatients() {
                return this.expiredFlyersPeriod
            }
        },

        created() {
            this.initialData()

            if (!this.fetching) {
                this.apiInvitedUsers({
                    countries: this.regionsLocalStorageParsed,
                    institutions: this.companiesLocalStorageParsed,
                    date_from: this.dateFromLocalStorage,
                    date_to: this.dateToLocalStorage
                })
            }
        },

        methods: {
            ...mapActions({
                apiInvitedUsers: 'reporting/apiInvitedUsers'
            }),

            initialData() {
                const regionsLocalStorage = window.localStorage.regions

                if (regionsLocalStorage) {
                    this.regionsLocalStorageParsed = JSON.parse(regionsLocalStorage)
                }

                const companiesLocalStorage = window.localStorage.companies

                if (companiesLocalStorage) {
                    this.companiesLocalStorageParsed = JSON.parse(companiesLocalStorage)
                }

                this.dateFromLocalStorage = window.localStorage.date_from
                this.dateToLocalStorage = window.localStorage.date_to

                if (!this.dateToLocalStorage && !this.dateFromLocalStorage) {
                    this.dateFromLocalStorage = moment()
                        .add(-7, 'days')
                        .format('YYYY-MM-DD')
                    this.dateToLocalStorage = moment().format('YYYY-MM-DD')
                }

                this.fetching = false

                return
            }
        }
    }
</script>
